import React,{useState} from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Web';
import LinkIcon from '@material-ui/icons/Link';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { Link, useLocation } from "react-router-dom";
import {makeStyles} from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

const useStyles = makeStyles(theme => ({

  listItemSpacing:{

      paddingLeft: "20px",
  },
  listItemSpacing2:{

    paddingLeft: "8px",
},
  selected: {
    boxShadow: '0 4px 20px 0 rgba(178, 152, 239, 0.14)', // sombra violeta suave
    background: '#f3f0fa', // opcional: fondo más claro
    borderRadius: 12,
  },
}))

export default function MainListItems(){
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  // Detecta si es mobile por el ancho de la pantalla
  const isMobile = window.innerWidth <= 768;
  const [open, setOpen] = useState(isMobile);
  //const [open, setOpen] = useState(false)
  const [openSubMenu, setOpenSubMenuSub] = useState(true)
  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
    
  };
  const handleClickSubMenu = () => {
    setOpenSubMenuSub(!openSubMenu)
  };


  return (
 <div>
    <ListItem
      button
      component={Link}
      to="/home"
      selected={location.pathname === "/home"}
      classes={{ selected: classes.selected }}
    >
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText secondary="Resumen" />
    </ListItem>

     <ListItem
      button
      component={Link}
      to="/linkcobro"
      selected={location.pathname === "/linkcobro"}
      classes={{ selected: classes.selected }}
    >
      <ListItemIcon>
        <LinkIcon/>
      </ListItemIcon>
      <ListItemText secondary="Link de cobro" />
      
    </ListItem>

   
   <ListItem
      button
      component={Link}
      to="/charts"
      selected={location.pathname === "/charts"}
      classes={{ selected: classes.selected }}
    >
      <ListItemIcon>
       <FormatListBulletedIcon/>
      </ListItemIcon>
      <ListItemText secondary="Historial de links" />
    </ListItem>

    <ListItem
      button
      component={Link}
      to="/txReports"
      selected={location.pathname === "/txReports"}
      classes={{ selected: classes.selected }}
    >
      <ListItemIcon>
       <AccountBalanceIcon/>
      </ListItemIcon>
      <ListItemText secondary="Transacciones" />
    </ListItem>
  </div>
  )
}
